module.exports = __webpack_public_path__ + "static/img/guanjun_0.ed2d5bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/guanjun_0.png
// module id = MG/P
// module chunks = 1